<!-- MAIN TABLE ---------------------------------------------------->
<p-table
  #dt1
  [value]="userData?.data"
  dataKey="id"
  styleClass="p-datatable-customers p-datatable-gridlines "
  [paginator]="false"
>
  <ng-template pTemplate="caption">
    <div [formGroup]="form" class="page-control flex align-items-start">
      <div class="grid w-100">
        <div
          class="col-12 flex justify-content-between mb-2 align-items-center"
        >
          <h2 class="text-black-alpha-90">Analiza - Radnik</h2>
          <div class="flex">
            <button
              class="main-btn"
              [disabled]="!form.valid || !userData"
              (click)="onExportPdf()"
              [ngClass]="{ disabled: !form.valid || !userData }"
            >
              Export PDF <i class="pi pi-file-pdf"></i>
            </button>

       
          </div>
        </div>

        <div class="col-4">
          <div class="mb-0 flex">
            <p-calendar
              dateFormat="dd.mm.yy"
              class="filter-calendar w-full"
              placeholder="Datum od"
              (onSelect)="onSearch()"
              [showIcon]="true"
              formControlName="date_from"
            ></p-calendar>
            <button
              class="clear-btn ml-2"
              (click)="clearFilters('date_from')"
              pTooltip="Obriši filter"
              tooltipPosition="top"
            >
              <i class="pi pi-times m-0"></i>
            </button>
          </div>
        </div>

        <div class="col-4">
          <div class="mb-0 flex">
            <p-calendar
              dateFormat="dd.mm.yy"
              class="filter-calendar w-full"
              placeholder="Datum do"
              (onSelect)="onSearch()"
              [showIcon]="true"
              formControlName="date_to"
            ></p-calendar>

            <button
              class="clear-btn ml-2"
              (click)="clearFilters('date_to')"
              pTooltip="Obriši filter"
              tooltipPosition="top"
            >
              <i class="pi pi-times m-0"></i>
            </button>
          </div>
        </div>

        <div class="col-4">
          <div class="flex mb-0">
            <p-dropdown
              [options]="allUsers"
              formControlName="userId"
              optionValue="id"
              optionLabel="name"
              [filter]="true"
              [showClear]="false"
              placeholder="Izaberi radnika"
              class="w-100"
              (onChange)="onSearch()"
            >
            </p-dropdown>
            <button
              class="clear-btn ml-2"
              (click)="clearFilters('userId')"
              pTooltip="Obriši filter"
              tooltipPosition="top"
            >
              <i class="pi pi-times m-0"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="header" >
    <tr *ngIf="userData">
      <th style="padding: 0.5rem">Datum</th>

      <th style="padding: 0.5rem" >Početak</th>
      <th style="padding: 0.5rem">Završetak</th>
      <th style="padding: 0.5rem">Vreme</th>
      <th style="padding: 0.5rem">Operacija</th>
      <th style="padding: 0.5rem">RN broj</th>
      <th style="padding: 0.5rem; width:10rem" >Šifra porizvoda</th>
      <th style="padding: 0.5rem">Planirano [kom]</th>
      <th style="padding: 0.5rem">Proizvedeno [kom]</th>
      <th style="padding: 0.5rem">Utrošeno vreme / JM [min/kom]</th>
      <th style="padding: 0.5rem">Škart</th>
      <th style="padding: 0.5rem">Razlog škarta/ pauze</th>
    </tr>

  </ng-template>

  <ng-template pTemplate="body" let-user>
    <tr [ngClass]="user.color">
        <td >
          <span >{{ user.date }}</span>
        </td>
        <td >
          <span >{{ user.start  }}</span>
        </td>
        <td>
            <span >{{ user.end }}</span>
        </td>
        <td>
            <span >{{ user.total_time }}</span>
        </td>
    
        <td>
            <span >{{ user.operation }}</span>
        </td>
        <td>
            <span >{{ user.batch }}</span>
        </td>
        <td>
            <span >{{ user.product }}</span>
        </td>
        <td>
            <span >{{ user.required_units}}</span>
        </td>
        <td>
            <span >{{ user.produced_units }}</span>
        </td>
        <td>
            <span >{{user?.spent_time_jm}}</span>
        </td>
        <td>
            <span >{{ user.scrap_amount }}</span>
        </td>
        <td>
            <span >{{ user.scrap_delay_reasons }}</span>
        </td>

        <!-- <td class="text-center">
          <ng-container *ngIf="!user.deleted_at">
            <a
              class="second-btn small-btn mr-2"
              pTooltip="Izmeni"
              tooltipPosition="top"
              (click)="onEditUser(user)"
              [routerLink]="['edit']"
            >
              <i class="pi pi-pencil"></i>
            </a>
            <button
              class="second-btn small-btn"
              type="button"
              pTooltip="Izbriši"
              tooltipPosition="top"
              (click)="onDeleteUser($event, user.id)"
            >
              <i class="pi pi-trash"></i>
            </button>
          </ng-container>
        </td> -->
      </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="10">Nema pronađenih prodataka.</td>
    </tr>
  </ng-template>
</p-table>

<!-- MAIN TABLE ---------------------------------------------------->


  <p-table    [value]="[userData]" *ngIf="userData"
   styleClass="p-datatable-customers p-datatable-gridlines "
  [paginator]="false">

  <ng-template pTemplate="header" >
    <tr >
      <th style="padding: 0.5rem">Ukupno vreme rada</th>
      <th style="padding: 0.5rem" >Ukupno vreme pauze</th>
      <th style="padding: 0.5rem">Ukupno vreme odjave</th>
  
    </tr>

  </ng-template>

  <ng-template pTemplate="body" let-user>
    <tr>
        <td>
          <span >{{ user.total_work_time }}</span>
        </td>
        <td>
          <span >{{ user.total_break_time  }}</span>
        </td>
        <td>
            <span >{{ user.total_logout_time }}</span>
        </td>
  
      

   
      </tr>
  </ng-template>
  </p-table>
